"use client"
import { Card } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import {
    Sheet,
    SheetContent,
    SheetTrigger
} from "@/components/ui/sheet";
import useLoginStore from "@/util/store/useLoginStore";
import useUserStore from "@/util/store/user";
import Aos from "aos";
import { ChevronDown, ChevronUp, CornerDownLeft, ListEnd, Menu, Minus, ShoppingBasket } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { dataLinkCategory } from "./LinkHeader";


const dataLinkProduct = [
    {
        title: "کرید اونتوس مردانه",
        src: "/product/creed-aventus-for-man-edp",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-08-01/aventus-100ml-bottle_3413e5f4-3eee-40b3-8451-2546a370ec5b-Photoroom (1) (1).png`
    },
    {
        title: "گود گرل مشکی",
        src: "/product/carolina-herrera-good-girl-for-women-edp",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-07-30/carolina-herrera-good-girl-eau-de-parfum-80ml_15239440_38169233_2048-Photoroom (1) (1).png`
    },
    {
        title: " باکارات رژ 540 سفید",
        src: "/product/maison-francis-kurkdjian-baccarat-rouge-540-for-women-and-men-edp",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-7-13/1720885426197-295909316.png`
    },
    {
        title: "دیورهوم اینتنس",
        src: "/product/dior-homme-intense-for-man-edt",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}images/2024-09-18/dior%20homme%20intense%20for%20man%20edt.png`
    },
    {
        title: "لانکوم لا ویه است بله",
        src: "/product/lancome-la-vie-est-belle-for-women-edp",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-09-03/lancome la vie est belle for women edp.png`
    },
    {
        title: "ژان پل گوتیه اسکندال",
        src: "/product/jean-paul-gaultier-scandal-for-women-edp",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-08-07/Jean-Paul-Gaultier-Scandal-8435415059060-www.atrinstar.ir_-Photoroom (2) (2).png`
    },
    {
        title: "دیور ساواج",
        src: "/product/dior-sauvage-for-man-edt",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-08-18/Y0685240_F068524009_E01_GHC-ezgif.com-webp-to-png-converter-Photoroom (1) (1).png`
    },
    {
        title: "مگاماره اورتو پاریسی",
        src: "/product/orto-parisi-megamare-for-women-and-man-parfum",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}images/2024-09-27/orto-parisi-megamare (2) (1).jpg`
    },
    {
        title: " باکارات رژ540 قرمز",
        src: "/product/maison-francis-kurkdjian-baccarat-rouge-540-for-women-and-men-extrait-de-parfum",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-7-13/1720885697534-689345180.png`
    },
    {
        title: "شنل بلو ادو پرفیوم",
        src: "/product/chanel-bleu-de-chanel-for-man-edp",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-08-01/9539149398046-Photoroom (1) (1) (1).png`
    },
    {
        title: "لالیک مشکی انکر نویر",
        src: "/product/lalique-encre-noire-for-man-edt",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}images/2024-09-14/%C3%98%C2%A7%C3%98%C2%AF%C3%9A%C2%A9%C3%99%C2%84%C3%99%C2%86%20%C3%99%C2%84%C3%98%C2%A7%C3%99%C2%84%C3%9B%C2%8C%C3%9A%C2%A9%20%C3%99%C2%85%C3%98%C2%B4%C3%9A%C2%A9%C3%9B%C2%8C%20%C3%98%C2%A7%C3%99%C2%86%C3%9A%C2%A9%C3%98%C2%B1%20%C3%99%C2%86%C3%99%C2%88%C3%9B%C2%8C%C3%98%C2%B1.png`
    },

    {
        title: "پاکو رابان اینویکتوس",
        src: "/product/paco-rabanne-invictus-for-men-edt",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-09-01/Untitled-design-79-Photoroom (1) (1) (1).png`
    },
    {
        title: "آنجلز شیر بای کیلیان",
        src: "/product/by-kilian-angels-share-women-and-man-edp",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}images/2024-10-07/cocktail-intense-perfume-bottle-against-white-background+(1) (1).webp`
    },
    {
        title: "دیور ساواج الکسیر",
        src: "/product/dior-sauvage-elixir-for-man-edp",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-08-22/Fragrance-World-Suave-Elixir-Man-Extrait-de-Parfum-80-ML-Photoroom (1) (2).png`
    },
    {
        title: "هرمس تق هرمس (ادو تویلت)",
        src: "/product/hermes-terre-d-hermes-for-man-edt",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-7-8/1720457680254-761224247.png`
    },
    {
        title: "ویکتوریا سکرت بامبشل",
        src: "/product/victoria-secret-bombshell-for-women-edp",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/0c4773dcfb668d58adb09b2ac44a6524-Photoroom (1) (2).png`
    },
    {
        title: "لالیک لامور زنانه",
        src: "/product/Lalique-L%E2%80%99Amour",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-7-4/1720102915293-317754891.png`
    },
    {
        title: "جورجیو آرمانی مای وی",
        src: "/product/giorgio-armani-my-way-for-women-edp",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-08-03/giorgio-armani-my-way-eau-de-parfum-37230863646962-Photoroom (1) (1).png`
    },
    {
        title: "شیسیدو زن زنانه",
        src: "/product/shiseido-zen-for-women-edp",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-7-6/1720272303023-694045909.png`
    },
    {
        title: "فلور نارکوتیک ایکس نیلهو",
        src: "/product/ex-nihilo-fleur-narcotique-for-women-and-men-edp",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-09-01/ex-nihilo-fleur-narcotique-fleur-narcotique-100ml (1)-Photoroom (1) (1).png`
    }
]


const MenuHeader = () => {
    const router = useRouter()
    const { token } = useUserStore();
    const { openLogin } = useLoginStore()
    const [open, setOpen] = useState(false)
    const [openIndexes, setOpenIndexes] = useState<any>({});
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        Aos.init({ duration: 500 });
    }, []);

    const toggleAccordion = (index: number) => {
        setOpenIndexes((prev: any) => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    const toggleAccordion2 = () => {
        setIsOpen(!isOpen);
    };


    return (
        <>
            <Sheet key={"right"} open={open} onOpenChange={() => setOpen(!open)}>
                <SheetTrigger asChild className="relative">
                    <button onClick={() => setOpen(true)} aria-label="menu-header" className="cursor-pointer bg-slate-200 h-10 w-10 shadow-md flex items-center justify-center rounded-[50%] p-1">
                        <Menu />
                    </button>
                </SheetTrigger>
                <SheetContent className="" aria-expanded={open} side={"right"}>
                    <Card className="p-4 pb-0">
                        <ScrollArea className="h-[100vh]" style={{ direction: "rtl" }}>
                            <nav className="grid  items-start px-2 text-sm font-medium lg:px-4">
                                <Link
                                    onClick={() => setOpen(false)}
                                    href="/"
                                    className={`flex  items-center gap-3 rounded-lg px-3 py-2 text-slate-700 hover:text-primary transition-all `}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
                                    </svg>
                                    صفحه اصلی
                                </Link>
                                {
                                    token ?
                                        <>
                                            <Link
                                                onClick={() => setOpen(false)}
                                                href="/profile"
                                                className={`flex items-center gap-3 rounded-lg px-3 py-2 text-slate-700 hover:text-primary transition-all`}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                                </svg>
                                                پروفایل
                                            </Link>
                                        </>
                                        :
                                        <span role="button" onClick={() => openLogin()} className="flex items-center gap-3 rounded-lg px-3 py-2 text-slate-700 hover:text-primary transition-all">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M7.864 4.243A7.5 7.5 0 0 1 19.5 10.5c0 2.92-.556 5.709-1.568 8.268M5.742 6.364A7.465 7.465 0 0 0 4.5 10.5a7.464 7.464 0 0 1-1.15 3.993m1.989 3.559A11.209 11.209 0 0 0 8.25 10.5a3.75 3.75 0 1 1 7.5 0c0 .527-.021 1.049-.064 1.565M12 10.5a14.94 14.94 0 0 1-3.6 9.75m6.633-4.596a18.666 18.666 0 0 1-2.485 5.33" />
                                            </svg>
                                            ورود یا ثبت نام
                                        </span>
                                }

                                <div className="h-full w-full grid border-r">
                                    <div className="text-sm flex items-center justify-between pb-5 pr-3">
                                        <div className="flex items-center justify-start">
                                            <ListEnd className="text-text1 ml-3 size-6" />
                                            <Link
                                                onClick={() => setOpen(false)} href="/categories/عطر">
                                                همه عطر ها
                                            </Link>
                                        </div>
                                    </div>
                                    {dataLinkCategory.map((cat, idx) => (
                                        <div key={idx}>
                                            <div className="text-sm flex items-center justify-between pb-5 pr-3 mr-3 border-r">
                                                <div className="flex items-center justify-start">
                                                    <CornerDownLeft className="text-text1 ml-3" />
                                                    <Link
                                                        onClick={() => setOpen(false)} href={cat.src} className="font-bold">
                                                        {cat.title}
                                                    </Link>
                                                </div>
                                                <div
                                                    onClick={() => toggleAccordion(idx)}
                                                    className="cursor-pointer"
                                                >
                                                    {openIndexes[idx] ? (
                                                        <ChevronUp className="size-4 ml-1" />
                                                    ) : (
                                                        <ChevronDown className="size-4 ml-1" />
                                                    )}
                                                </div>
                                            </div>
                                            {openIndexes[idx] && (
                                                <div

                                                    className="ml-6"
                                                >
                                                    {cat.children.map((child, childIdx) => (
                                                        <div data-aos="fade-zoom-in"
                                                            data-aos-delay={`${childIdx * 100}`} key={childIdx} className="text-sm flex items-center pb-5 pr-3 border-r mr-6">
                                                            <Minus />
                                                            <Link
                                                                onClick={() => setOpen(false)} href={child.src} className="text-gray-700">
                                                                {child.title}
                                                            </Link>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                                <div className="rounded-md">
                                    <div
                                        onClick={toggleAccordion2}
                                        className="flex items-center justify-between cursor-pointer mt-5 pr-3 bg-white rounded-md shadow-sm font-bold text-text"
                                    >
                                        <div className="flex items-center justify-start">
                                            <ShoppingBasket className="text-text1 ml-3" />
                                            <span>محبوب‌ترین عطر ها</span>
                                        </div>
                                        {isOpen ? <ChevronUp className="size-4 ml-1" /> : <ChevronDown className="size-4 ml-1" />}
                                    </div>
                                    {isOpen && (
                                        <div data-aos="fade-zoom-in" className="mt-3">
                                            {dataLinkProduct.map((product, idx) => (
                                                <Link
                                                    onClick={() => setOpen(false)} key={idx} href={product?.src} className="flex items-center my-2 p-2 hover:bg-gray-50 rounded-md transition">
                                                    <Image src={product?.img} alt={product?.title} width={50} height={50} className="rounded-sm" />
                                                    <Minus className="text-gray-400 ml-2" />
                                                    <span className="text-sm text-gray-700">{product?.title}</span>
                                                </Link>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                <Link
                                    onClick={() => setOpen(false)} href={"/brands"}
                                    className={`flex items-center gap-3 rounded-lg text-slate-700 hover:text-primary px-3 py-2 transition-all`}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0 0 12 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75Z" />
                                    </svg>
                                    برند ها
                                </Link>
                                <Link
                                    onClick={() => setOpen(false)} href={"/essence"}
                                    className={`flex items-center gap-3 rounded-lg text-slate-700 hover:text-primary px-3 py-2 transition-all`}

                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z" />
                                    </svg>

                                    اسانس ها
                                </Link>
                                <Link
                                    onClick={() => setOpen(false)} href={"/creator"}
                                    className={`flex items-center gap-3 rounded-lg text-slate-700 hover:text-primary px-3 py-2 transition-all`}

                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                    </svg>

                                    سازنده ها
                                </Link>
                                <Link
                                    onClick={() => setOpen(false)} href={"/blog"}
                                    className={`flex items-center gap-3 rounded-lg text-slate-700 hover:text-primary px-3 py-2 transition-all`}

                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                                    </svg>

                                    مقاله ها
                                </Link>
                                <Link
                                    href={"/track-order"}
                                    className={`flex items-center gap-3 rounded-lg text-slate-700 hover:text-primary px-3 py-2 transition-all`}
                                    onClick={() => setOpen(false)}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5" />
                                    </svg>

                                    پیگیری سفارش
                                </Link>
                                <Link
                                    href={"/about"}
                                    className={`flex items-center gap-3 rounded-lg text-slate-700 hover:text-primary px-3 py-2 transition-all`}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                                    </svg>

                                    درباره ما
                                </Link>
                                <Link
                                    onClick={() => setOpen(false)} href={"/contact"}
                                    className={`flex items-center gap-3 rounded-lg $text-slate-700 hover:text-primary px-3 py-2 transition-all`}

                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155" />
                                    </svg>
                                    تماس با ما
                                </Link>
                                {token ? <span
                                    onClick={() => {
                                        router.push("/auth")
                                    }}
                                    className={`flex items-center gap-3 rounded-lg px-3 py-2 text-slate-700 transition-all hover:text-primary`}
                                >
                                    <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5" />
                                        </svg>
                                    </span>
                                    خروج
                                </span> : null}
                            </nav>
                        </ScrollArea>
                    </Card>
                </SheetContent>
            </Sheet>
        </>

    )
};

export default MenuHeader;
